import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    SprayEventTotalArea,
    SprayEntityIds
} from 'services/sprayEvents/types';
import { makeSelectTotalArea } from './selectors';

interface ConnectedProps {
    totalArea: SprayEventTotalArea;
}

interface OwnProps {
    productId: ProductId;
    entityIds: SprayEntityIds;
    needHalfCalculation: boolean;
}

export type Props = ConnectedProps & OwnProps;

export class TotalAreaListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { totalArea } = this.props;

        return <ListItem value={`${totalArea} Ha`} description="Total area" />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    totalArea: makeSelectTotalArea()
});

export default connect(mapStateToProps)(TotalAreaListItemComponent);
